export const BreadCrumbLink = '#98a9bc'
export const BreadCrumbLinkActive = '#92929dCC'
export const FilterBackground = '#E5EBF2'
export const FilterBorder = '#C6CDDA'
export const BodyBackground = '#EBF6FD'
export const TableRowBackground = '#F6FAFD'